import React from "react";

export const laLagunaEncantadaPublishedAT = (
  <span className="white">
    <i>Rin Rin, Revista infantil del Ministerio de Educación</i>, No. 13 (1939) y <i>Otra vez en Lilac</i> (1942)
  </span>
);
